import { GodotSourceLibrary } from "./GodotSourceLibrary";

export class GodotSource
{
  static createCoreMap()
  {
    var map = new Map<string,string>();

    // modules\mono\glue\GodotSharp\GodotSharp\Core

    var coreTypes = [
      "Color", 
      "Vector2",
      "Vector3",
      "Vector4",
      "Vector2i",
      "Vector3i",
      "Vector4i",
      "Basis",
      "Rect2",
      "Rect2i",
      "Transform2D",
      "Transform3D",
      "AABB",
      "Plane",
      "Quaternion"
    ];

    coreTypes.forEach(
      ( ct )=>
      {
        let libName = ct.toLowerCase().replace( /2d$/,"_2d" ).replace( /3d$/,"_3d" ) + ".h";
        
        map.set( ct, "core/math/" + libName );
      }
    )

    return map;

  }


  static _sourceMap = GodotSource.createCoreMap();

  static isCore( className:string )
  {
    return this._sourceMap.has( className );
  }

  static hasType( className:string )
  {
    return this.getTypePath( className ) != null;
  }

  static getCSCoreTypePath( className:string )
  {
    if ( className == "AABB" )
    {
      className = "Aabb";
    }
    let csSourcePath = "modules/mono/glue/GodotSharp/GodotSharp/Core/" +  className + ".cs";
    return csSourcePath;
  }

  static getTypePath( className:string )
  {
    if ( GodotSource._sourceMap.has( className ) )
    {
      return GodotSource._sourceMap.get( className );
    } 

    if ( GodotSourceLibrary.sourceMap.has( className ) )
    {
      return GodotSourceLibrary.sourceMap.get( className );
    }


    return null;
  }
}